// extracted by mini-css-extract-plugin
export default {"app":"App_app__l8KP0","content":"App_content__N5xfb"};